import React, { useContext, useCallback, useState } from 'react';
import DocsTask from 'containers/Docs/DocsTask';
import DocsContext from 'containers/Docs/context/DocsContext';
import { Button } from '@ontruck/orc';
import DocsTaskDetail from 'containers/Docs/DocsTaskDetail';
import { Loading } from 'components/Loading';
import DocsCreateCarrier from 'containers/Docs/DocsCreateCarrier';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import DocsFilters from 'containers/Docs/DocsFilters';

const t = {
  docType: 'Document Type',
  validUntil: 'Valid Until',
  discard: 'Discard document',
  validate: 'Validate document',
  createCarrier: 'Create carrier',
  error: 'There was an error fetching the document',
  errorTasks: 'There was an error fetching the documents',
  tip: 'Please select a document at the side to start validation process.',
  reloadPage: 'Reload Page',
  noMatch: 'There are no pending documents with that filters.',
};

const DocsHome = ({ className }) => {
  const { tasks, loadingTasks, createCarrier, tasksError } = useContext(DocsContext);
  const [showCarrierModal, setShowCarrierModal] = useState(false);
  const { docId } = useParams();

  const sortByDateField = (array, field) => {
    return array.sort((a, b) => {
      if (moment(a[field]).toDate() === moment(b[field]).toDate()) {
        return a.id - b.id;
      }
      return moment(a[field]).toDate() - moment(b[field]).toDate();
    });
  };

  const renderTasks = useCallback(() => {
    if (tasksError) {
      return (
        <div className="docs-home__error" data-testid="docs-home__error">
          {t.errorTasks}
        </div>
      );
    }
    if (loadingTasks || !tasks) {
      return (
        <div className="docs-home__loading" data-testid="docs-home__loading">
          <Loading />
        </div>
      );
    }
    if (tasks && tasks.length === 0) {
      return (
        <div className="docs-home__no-match" data-testid="docs-home__no-match">
          {t.noMatch}
        </div>
      );
    }
    return sortByDateField(tasks, 'date_added').map((task) => (
      <DocsTask task={task} key={task.id} />
    ));
  }, [tasks, loadingTasks, tasksError]);

  const handleOopenModal = useCallback(() => {
    setShowCarrierModal(!showCarrierModal);
  }, [showCarrierModal]);

  const handleCloseModal = useCallback(() => {
    setShowCarrierModal(false);
  }, []);

  const handleCreateCarrier = useCallback(
    (carrier) => {
      createCarrier(carrier, handleCloseModal);
    },
    [createCarrier, handleCloseModal]
  );

  return (
    <div className={className}>
      <div className="docs-home" data-testid="docs-home">
        <div className="docs-home__side">
          <DocsFilters />
          {renderTasks()}
        </div>
        <div className="docs-home__content">
          {/*We are hiding the create carrier feature for the moment*/}
          {false && (
            <div className="docs-home__bar">
              <Button text={t.createCarrier} ghost skin="secondary" onClick={handleOopenModal} />
            </div>
          )}
          {docId && <DocsTaskDetail />}
          {!docId && <div className="docs-home__tip">{t.tip}</div>}
        </div>
        <DocsCreateCarrier
          show={showCarrierModal}
          handleCreateCarrier={handleCreateCarrier}
          onClose={handleCloseModal}
        />
      </div>
    </div>
  );
};

export default DocsHome;
